import {Link, useParams, useNavigate} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as Tooltip1, Legend, LineChart, Line } from 'recharts';

//import { , XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
//import { DotItemDotProps } from 'recharts/types/util/types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';

import './css/analytics.css';

class PortalServiceAnalytics extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			
			view: {
				charts: '',
				page: '',
			},
			
			platforms: {
				followers: [],
				platforms: []
			},

			djs: [],
			djsChart: [
				{bar: 'hours', enabled: true, fill: "#A8CAE6"},
				{bar: 'performances', enabled: true, fill: "#E3B321"},
				{bar: 'followers', enabled: true, fill: "#86AE11"},
				{bar: 'messages', enabled: false, fill: "#ED8D51"},
				{bar: 'twitch_bits', enabled: true, fill: "#219696"},
				{bar: 'twitch_subscribe', enabled: true, fill: "#C95050"},
				{bar: 'twitch_trains', enabled: true, fill: "#8F548F"}
			],

			start: Math.floor(Date.now()/1000),
			end: Math.floor(Date.now()/1000)
		};
    this.getAnalytics = this.getAnalytics.bind(this);
		this.setView = this.setView.bind(this);
		this.sortDjs = this.sortDjs.bind(this);
		//this.length = this.length.bind(this);
  };

  async componentDidMount() {
		

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		EventEmitter.emit('/client', y);

		this.getAnalytics();
	}

	componentWillUnmount() {
    
	}

	async getAnalytics() {
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${value.worker[this.state.service.id]}/v3/service/analytics`, params);
		consoleLog(x.data);
		setTitle('Analytics', x.data.servicename);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				//this.setState({});
				setTitle('Analytics', x.data.servicename);
			}
      x.data.djs.sort((a, b) => a.hours < b.hours);
			for( let i in x.data.platforms.platforms ) {
				for( let j in x.data.platforms.platforms[i] ) {
					//console.log(x.data.platforms.platforms[i][j]);
					x.data.platforms.platforms[i][j].date = moment(x.data.platforms.platforms[i][j].ctime*1000).format('DD-MMM');
				}
			}
				
			this.setState({
				service,
				djs: x.data.djs,
				platforms: x.data.platforms,
				view: {charts: 'platforms', page: x.data.platforms.platforms.length-1},
				start: x.data.platforms.start,
				end: x.data.platforms.end
			});
		}
	}


	setView(charts, page = null, enabled = null) {
		let djs = this.state.djs;
		let djsChart = this.state.djsChart;

		if( charts === 'platforms' ) {
			if( page === null ) page = this.state.platforms.platforms.length-1;
		} else {

		}


		this.setState({view: {charts, page}, djs, djsChart});
	}


	sortDjs(bar, enabled = null) {
		
		let djs = this.state.djs;
		let djsChart = this.state.djsChart;
		if( enabled === null ) {
			//console.log(djsChart);

			let element = djsChart.find(elem=>elem.bar===bar);
			element.enabled = true;
			let index = djsChart.findIndex(elem=>elem.bar===bar);
			//console.log(element, index);
	    djsChart.splice(index, 1);
    	djsChart.splice(0, 0, element);
			djs = djs.toSorted((a, b) => b[bar] - a[bar]);

		} else {

			let element = djsChart.find(elem=>elem.bar===bar);
			element.enabled = enabled;

		}

		//console.log(djs, djsChart);
		this.setState({djs, djsChart});
	}

	render() {
    const user = this.context;

		const followers = this.state.platforms.followers.map((e, i) => {
			return (
				<Col key={i}>
					<div className="card custom-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="me-2">
									<div className="avatar avatar-md bg-success-transparent">
										<img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} alt="Platform Avatar" />
									</div>
								</div>
								<div className="flex-1">
									<a aria-label="anchor" href="javascript:void(0)" className="tx-inverse float-end text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots tx-14"></i></a>
									<ul className="dropdown-menu">
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Another Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item">Something Else Here</a></li>
									</ul>
									<div className="mg-b-6">
										<p className="mb-0 tx-13 text-muted">{e.username} Followers</p>
									</div>
									<div className="flex-between">
										<h3 className="tx-20 mb-0 font-weight-normal">{e.followers}</h3>
									</div>
									<div>
										{e?.twitch_bits > 0 &&
											<>Bits {e.twitch_bits}, </>
										}
										{e?.twitch_subscribe > 0 &&
											<>Subscribers {e.twitch_subscribe}, </>
										}
										{e?.twitch_trains > 0 &&
											<>Trains {e.twitch_trains}, </>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Col>
			)
		});

		const CustomizedDot = (props) => {
  		//const { cx, cy, value } = props;
			const scale = 0.25;
			//console.log(props);
			if( props.cy )
				return (
					<svg xmlns="http://www.w3.org/2000/svg">
						<title>icon27.1g</title>
						<g id="train" transform={`translate(${props.cx-128*scale/2},${props.cy-128*scale/2}) scale(${scale})`}>
							<rect x="15.48" y="25.49" width="5.07" height="18.91"/>
							<path d="M114.29,82.64V67.4a19.024,19.024,0,0,0-19-19H11.95a3.009,3.009,0,0,0-3,3v7.03H55.67a2,2,0,0,1,0,4H8.95V85.64H111.29A3,3,0,0,0,114.29,82.64Z"/>
							<path d="M26.1,105.643a2.774,2.774,0,1,0,2.775,2.773A2.776,2.776,0,0,0,26.1,105.643Z"/>
							<path d="M26.1,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,26.1,96.99Zm0,18.2a6.774,6.774,0,1,1,6.775-6.774A6.781,6.781,0,0,1,26.1,115.19Z"/>
							<rect x="24.55" y="25.49" width="21.55" height="18.91"/>
							<rect x="76.51" y="32.22" width="13.64" height="12.18"/>
							<rect x="6.95" y="8.16" width="56.74" height="13.33" rx="3"/>
							<rect x="50.1" y="25.49" width="5.06" height="18.91"/>
							<path d="M112.49,89.64H8.95v15.8a3.02,3.02,0,0,0,1.74,2.72,15.421,15.421,0,0,1,30.84.26v.02h6.48v-.02a15.425,15.425,0,1,1,30.85,0v.02h6.48v-.02a15.425,15.425,0,1,1,30.85,0v.02h1.85a3.007,3.007,0,0,0,2.61-4.49Z"/>
							<path d="M100.76,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,100.76,96.99Zm0,18.2a6.774,6.774,0,1,1,6.773-6.774A6.781,6.781,0,0,1,100.763,115.19Z"/>
							<path d="M74.92,28.22H91.74a1.805,1.805,0,0,0,0-3.61H74.92a1.805,1.805,0,0,0,0,3.61Z"/>
							<path d="M100.763,105.643a2.774,2.774,0,1,0,2.773,2.773A2.776,2.776,0,0,0,100.763,105.643Z"/>
							<path d="M63.43,96.99a11.425,11.425,0,1,0,11.43,11.43A11.438,11.438,0,0,0,63.43,96.99Zm0,18.2a6.774,6.774,0,1,1,6.773-6.774A6.781,6.781,0,0,1,63.434,115.19Z"/>
							<path d="M63.434,105.643a2.774,2.774,0,1,0,2.773,2.773A2.776,2.776,0,0,0,63.434,105.643Z"/>
						</g>
					</svg>
			)
		}

		const CustomTooltip = ({ active, payload, label }) => {
			const isVisible = active && payload && payload.length;
			return (
				<div className="custom-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden', backgroundColor: '#ffffff' }}>
					{isVisible && (
						<>

							<div xmlns="http://www.w3.org/1999/xhtml" tabindex="-1" class="recharts-tooltip-wrapper recharts-tooltip-wrapper-right recharts-tooltip-wrapper-bottom" style={{visibility: 'visible'}}>
								<div class="recharts-default-tooltip" style={{margin: 0, padding: 10, backgroundColor: 'rgb(255, 255, 255)', border: '1px solid rgb(204, 204, 204)', whiteSpace: 'nowrap'}}>
									<p class="recharts-tooltip-label" style={{margin: 0}}>{label}</p>
									<ul class="recharts-tooltip-item-list" style={{padding: 0, margin: 0}}>
										{payload[0].payload.twitch_bits &&
											<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: 'rgb(130, 202, 157)'}}>
												<span class="recharts-tooltip-item-name">Twitch Bits: {payload[0].payload.twitch_bits}</span>
											</li>
										}
										{payload[0].payload.twitch_subscribe &&
											<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: 'rgb(130, 202, 157)'}}>
												<span class="recharts-tooltip-item-name">Twitch Subscribe: {payload[0].payload.twitch_subscribe}</span>
											</li>
										}
										{payload[0].payload._twitch_trains &&
											<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: 'rgb(130, 202, 157)'}}>
												<span class="recharts-tooltip-item-name">Twitch Trains: {payload[0].payload._twitch_trains}</span>
											</li>
										}
										{Object.keys(payload[0].payload).map((e, i) =>{
											//console.log(typeof payload[0].payload[e]);
											if( typeof payload[0].payload[e] === 'object' )
												return (
													<li key={i} class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: 'rgb(130, 202, 157)'}}>
														<span class="recharts-tooltip-item-name">{e}: {payload[0].payload[e].length}</span>
														<div className="d-flex">
															<div className="avatar-list-stacked">
																{payload[0].payload[e].map((f, j) =>{
																	return (
																		<div key={j} className="avatar avatar-md" >
																			<img alt="avatar" className="rounded-circle" src={f.avatar} />
																		</div>
																	)
																})}
															</div>
														</div>
													</li>
												)
										})}
										{/*<li class="recharts-tooltip-item" style={{display: 'block', paddingTop: 4, paddingBottom: 4, color: 'rgb(130, 202, 157)'}}>
											<span class="recharts-tooltip-item-name">value</span>
											<span class="recharts-tooltip-item-separator"> : </span>
											<span class="recharts-tooltip-item-value">2</span>
											<span class="recharts-tooltip-item-unit"></span>
										</li>*/}
										
									</ul>
								</div>
							</div>


							{/*<p className="label">{`${label} : ${payload[0].value}`}</p>
							<p className="intro">Something</p>
							<p className="desc">Anything you want can be displayed here.</p>*/}
						</>
					)}
				</div>
			);
		};
		

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Analytics</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<Col xs={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Analytics</span>
													<p className="fs-13 text-muted mb-0">View your radio station analytics.</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                </Col>
              </Row>
							<Row>
								{followers}
							</Row>
							<Row>
								<Col xs={12}>
									<div className="card">
										<div className="card-body">
											<p className="my-0">
												Date period: {moment(this.state.start*1000).format('DD-MMM-YY')} to {moment(this.state.end*1000).format('DD-MMM-YY')}
											</p>
											<ButtonGroup size="sm" className="py-2">
												<Button variant={this.state.view.charts==='platforms'?'outline-dark':'light'} onClick={()=>this.setView('platforms')}>Platforms's</Button>
												<Button variant={this.state.view.charts==='djs'?'outline-dark':'light'} onClick={()=>this.setView('djs')}>DJ'S</Button>
												<Button variant={'light'}></Button>

												{this.state.view.charts === 'platforms' &&
													this.state.platforms.platforms.map((e,i) => {
														return (
															<Button key={i} variant={this.state.view.page===i?'outline-dark':'light'} onClick={()=>this.setView('platforms', i)}>{moment(e[0].ctime*1000).format('MMM YY')}</Button>
														)
													})}
												{this.state.view.charts === 'djs' &&
													this.state.djsChart.map((e, i)=>{
														return (
															<React.Fragment key={i}>
																<button onClick={()=>this.sortDjs(e.bar)} style={{backgroundColor: e.fill, color: '#ffffff', borderColor: e.fill, padding: '0 .5rem', borderRight: 0}}>
																	{e.bar.charAt(0).toUpperCase() + String(e.bar).slice(1)}
																</button>
																<button onClick={()=>this.sortDjs(e.bar, !e.enabled)} style={{backgroundColor: e.fill, color: '#ffffff', borderColor: e.fill, padding: '0 .5rem', borderLeft: 0}}>
																	{e.enabled === true ?
																		<span className="custom-check"><FontAwesomeIcon icon="square-check" /></span>
																	:
																		<span className="custom-check"><FontAwesomeIcon icon="square" /></span>
																	}
																</button>
															</React.Fragment>
														)
													})}
											</ButtonGroup>

											{this.state.view.charts === 'platforms' &&

												<LineChart
													style={{ width: '100%', maxHeight: '50vh', aspectRatio: 1.618 }}
													responsive
													data={this.state.platforms.platforms[this.state.view.page]}
													margin={{
														top: 5,
														right: 10,
														left: 0,
														bottom: 5,
													}}
												>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis dataKey="date" />
													<YAxis width="auto" />
													<Tooltip1 content={CustomTooltip} />
													<Legend />
													
													<Line type="monotone" dataKey="value" stroke="#82ca9d" /*dot={CustomizedDot}*/ />
													<Line type="monotone" dataKey="twitch_trains" stroke="#82ca9d" dot={CustomizedDot} />
													{/*this.state.platforms.followers.map((e,i) => {
														return (
															<Line key={i} type="monotone" dataKey={e.platform} stroke="#8884d8" /*dot={CustomizedDot}* />
														)
													})*/}
												</LineChart>
											}
											{this.state.view.charts === 'djs' &&
												<BarChart
													style={{ width: '100%', maxHeight: '50vh', aspectRatio: 1.618 }}
													responsive
													data={this.state.djs}
													margin={{
														top: 20,
														right: 0,
														left: 0,
														bottom: 50,
													}}
												>
													<CartesianGrid strokeDasharray="3 3" />
													<XAxis dataKey="username" tick={{textAnchor: "end"}} angle={-35} />
													<YAxis width="auto" />
													<Tooltip1 />
													<Legend verticalAlign="top" />
													{this.state.djsChart.filter(elem=>elem.enabled===true).map((e, i)=>{
														return (
															<Bar key={i} dataKey={e.bar} stackId={parseInt(i)===0?'a':'b'} label={{fill: 'white'}} fill={e.fill} background />
														)
													})}
												</BarChart>
											}
										</div>
									</div>
								</Col>
								
							</Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Analytics = props => {
  const { service } = useParams();
  const navigate = useNavigate();
  return <PortalServiceAnalytics service={service} navigate={navigate} {...props} />
}
export default Analytics;